import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../styles/Header.css';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    setMenuOpen(false);

    if (location.pathname !== '/') {
      // Navigate to home first, then scroll
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // Already on home page, just scroll
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleLinkClick = () => {
    setMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <nav className="nav">
          {/* Logo */}
          <div className="logo">
            <Link to="/" onClick={handleLinkClick}>
              <span className="logo-text">FortIf</span>
              <span className="logo-badge">AI</span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <ul className={`nav-menu ${menuOpen ? 'active' : ''}`}>
            <li className="nav-item">
              <a href="#home" className="nav-link" onClick={(e) => scrollToSection(e, 'home')}>
                Home
              </a>
            </li>
            <li className="nav-item">
              <a href="#features" className="nav-link" onClick={(e) => scrollToSection(e, 'features')}>
                Features
              </a>
            </li>
            <li className="nav-item">
              <a href="#pricing" className="nav-link" onClick={(e) => scrollToSection(e, 'pricing')}>
                Pricing
              </a>
            </li>
            <li className="nav-item">
              <Link to="/faq" className="nav-link" onClick={handleLinkClick}>
                FAQ
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/about" className="nav-link" onClick={handleLinkClick}>
                About
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/contact" className="nav-link" onClick={handleLinkClick}>
                Contact
              </Link>
            </li>
            <li className="nav-item nav-item-cta">
              <a
                href="#pricing"
                className="btn btn-primary btn-small"
                onClick={(e) => scrollToSection(e, 'pricing')}
              >
                Get Started
              </a>
            </li>
          </ul>

          {/* Mobile Menu Toggle */}
          <button
            className={`menu-toggle ${menuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
        </nav>
      </div>
    </header>
  );
}

export default Header;
